import React from 'react';
import Select from '../Select';
import { shortenSha } from '../../../helpers';
import { useStyles } from './styles';
const SelectCommit = ({ selected, options, onClose, onChange }) => {
    const ownClasses = useStyles();
    return (React.createElement(Select, { selected: selected, options: options, onClose: onClose, onChange: onChange, idToNameConvertor: sha => shortenSha(sha), classes: { input: ownClasses.input, option: ownClasses.option } }));
};
export default SelectCommit;
